<template>
  <div class="bg">
    <top ref="top"></top>
    <page-main></page-main>
    <FloatingButton @scrollToTop="scrollToTop" v-if="$route.path!=='/login' && $store.state.isRole != 4"/> <!-- 悬浮按钮 -->
    <bottom></bottom>
  </div>
</template>

<script>
  import {Top,Bottom, PageMain} from './components'
  import FloatingButton from "./components/FloatingButton.vue";
  import { EventBus } from '@/utils/eventBus.js';
  import { MessageBox } from 'element-ui';
  import { getShareSwitchMessage } from '@/utils/shareDemandAuth';
  export default {
    components: {
      FloatingButton,
      Top,
      Bottom,
      PageMain
    },
    data(){
      return{
      }
    },
    watch: {
      '$route.name': function (val) {
        this.$nextTick(() => {
          this.scrollToTop()
        });
      },
      '$route': function (to,from) {
        // console.log(to,from)
        if(!from.query.activeName) {
          this.$store.commit('setActiveName', '');
        }
      },
      '$route.query.shareSwitch': {
        immediate: true,
        handler(val) {
          if (val === '1' && this.$route.query.redirect) {
            this.handleShareSwitch()
          }
        }
      },
    },
    mounted() {
      EventBus.$on('scrollToTop', this.scrollToTop);
    },
    beforeDestroy() {
      EventBus.$off('scrollToTop', this.scrollToTop);
    },
    methods: {
      handleShareSwitch() {
        if (this._shareSwitchShowing) {
          return
        }
        this._shareSwitchShowing = true
        const redirectPath = this.$route.query.redirect
        const message = getShareSwitchMessage(
          this.$store.state.isRole,
          (key, params) => this.$t(key, params)
        )
        MessageBox.alert(message, this.$t('提示'), {
          confirmButtonText: this.$t('确认'),
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(() => {
          this.$store.commit('changeIsRole', '2')
          this.$router.replace(redirectPath)
        }).finally(() => {
          this._shareSwitchShowing = false
        })
      },
      // 返回顶部方法
      scrollToTop() {
        const container = document.querySelector('.bg');
        if (container) {
          container.scrollTop = 0; // 滚动容器回到顶部
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .bg {
    width: 100vw;
    height: 100vh;
    //min-width: 1200px;
    overflow-x: auto;
    overflow-y: auto;
    background-color: #e1e4e5;
  }
  /* 允许滚动内容但隐藏滚动条 */
  //.bg::-webkit-scrollbar {
  //  display: none;
  //}
  /* 对于 Firefox 浏览器 */
  html {
    scrollbar-width: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue